module.exports = __webpack_public_path__ + "img/loading_2.cb8a2770.gif";